<template>
    <div class="badge">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 118.057 162.016" enable-background="new 0 0 118.057 162.016" xml:space="preserve" ref="badge">
            <g id="badge">
                <path id="outerring" class="badge-piece" d="M59.996,71.07c-23.413,0-42.393,18.98-42.393,42.393c0,23.413,18.98,42.393,42.393,42.393
                    s42.393-18.98,42.393-42.393C102.389,90.05,83.409,71.07,59.996,71.07z M59.996,148.368c-19.278,0-34.905-15.628-34.905-34.905
                    c0-19.278,15.628-34.905,34.905-34.905s34.905,15.628,34.905,34.905C94.901,132.741,79.273,148.368,59.996,148.368z"/>
            </g>
            <g class="icons" v-if="earned">
                <path  v-if="icon === 'circle'" id="badge-icon-circle" class="badge-piece" d="M59.996,86.096c-15.115,0-27.367,12.253-27.367,27.367c0,15.115,12.253,27.367,27.367,27.367
                    s27.367-12.253,27.367-27.367C87.363,98.349,75.11,86.096,59.996,86.096z"/>
                <polygon v-if="icon === 'check'" id="badge-icon-check" class="badge-piece" points="55.215,128.724 40.497,114.01 47.568,106.937 55.357,114.726 72.568,98.203 
                    79.494,105.418 	"/> 
                <polygon v-if="icon === 'star'" id="badge-icon-star" class="badge-piece" points="71.76,131.565 59.993,123.016 48.229,131.561 52.724,117.733 40.963,109.188 
                    55.502,109.188 59.997,95.361 64.488,109.188 79.029,109.188 67.264,117.734 	"/>
            </g>
            <g id="lanyard">
                <polygon id="landyard3" class="badge-piece" points="29.666,6.248 40.329,30.206 77.804,30.433 88.091,6.248 	"/>
                <path id="lanyard2" class="badge-piece" d="M89.139,72.264l23.724-49.503l-10.69-16.514h-6.236L70.259,63.941
                    C77.183,65.402,83.578,68.286,89.139,72.264z"/>
                <path id="lanyard1" class="badge-piece" d="M47.938,64.256L22.12,6.248h-4.733L5.194,22.762l24.044,50.367
                    C34.706,68.972,41.047,65.912,47.938,64.256z"/>
            </g>
        </svg>
    </div>
</template>

<script>
    import { gsap } from '/src/assets/js/gsap';
    import { DrawSVGPlugin } from '/src/assets/js/gsap/DrawSVGPlugin';
    
    export default {
        name : "Badge",
        props : { 
            earned:Boolean,
            icon: {
                type: String,
                default: 'circle'
            }
        },
        mounted () {
            gsap.registerPlugin(DrawSVGPlugin);
        },
        watch: {
            earned (newVal, oldVal) {
                if (newVal) {
                    this.animateBadge()
                    return true
                } else return false
            },
            icon (newVal, oldVal) {
                return newVal
            }
        },
        methods: {
            animateBadge () {
                this.$nextTick(() => {
                    let ref = this.$refs.badge;
                    let bRef = ref.querySelectorAll(".badge-piece");
                    gsap.from(bRef, { drawSVG: "0%", duration: 1, autoAlpha: 0, delay: 0.5, scale: 0.5, transformOrigin: 'center center' })
                    gsap.to(bRef, { fill: "white", duration: 1, delay: 0.75 })
                    gsap.to(bRef, { drawSVG: "0%", duration: 0.35, delay: 1.7 })   
                })
                
                
                
            }
        }
    }
</script>

